export type OrderTrackingColumnId =
  | 'warehouse'
  | 'orderDate'
  | 'expectedDate'
  | 'daysToDue'
  | 'health'
  | 'progressUnits'
  | 'progressProducts'
  | 'pendingProducts'
  | 'qtyOrdered'
  | 'qtyReceived'
  | 'qtyPending'
  | 'pendingValue'
  | 'totalValue'
  | 'salesOrder'
  | 'leadTime'
  | 'reception'
  | 'linesCount'
  | 'linesWithSO'
  | 'linesWithoutSO';

export const ORDER_TRACKING_TABLE_COLUMN_CONFIG_KEY = 'orderTracking.table.columnConfig.session.v4';

export const DEFAULT_COLUMN_CONFIG: Record<OrderTrackingColumnId, boolean> = {
  warehouse: false,
  orderDate: true,
  expectedDate: true,
  daysToDue: true,
  health: true,
  progressUnits: true,
  progressProducts: true,
  pendingProducts: true,
  qtyOrdered: false,
  qtyReceived: false,
  qtyPending: false,
  pendingValue: true,
  totalValue: false,
  salesOrder: true,
  leadTime: false,
  reception: false,
  linesCount: false,
  linesWithSO: false,
  linesWithoutSO: false,
};

export const ORDER_TRACKING_OPTIONAL_COLUMNS: { id: OrderTrackingColumnId; labelKey: string }[] = [
  { id: 'warehouse', labelKey: 'orderTracking.table.columns.warehouse' },
  { id: 'orderDate', labelKey: 'orderTracking.table.columns.orderDate' },
  { id: 'expectedDate', labelKey: 'orderTracking.table.columns.expectedDate' },
  { id: 'daysToDue', labelKey: 'orderTracking.table.columns.daysToDue' },
  { id: 'health', labelKey: 'orderTracking.table.columns.health' },
  { id: 'progressUnits', labelKey: 'orderTracking.table.columns.progressUnits' },
  { id: 'progressProducts', labelKey: 'orderTracking.table.columns.progressProducts' },
  { id: 'pendingProducts', labelKey: 'orderTracking.table.columns.pendingProducts' },
  { id: 'qtyOrdered', labelKey: 'orderTracking.table.columns.qtyOrdered' },
  { id: 'qtyReceived', labelKey: 'orderTracking.table.columns.qtyReceived' },
  { id: 'qtyPending', labelKey: 'orderTracking.table.columns.qtyPending' },
  { id: 'pendingValue', labelKey: 'orderTracking.table.columns.pendingValue' },
  { id: 'totalValue', labelKey: 'orderTracking.table.columns.totalValue' },
  { id: 'salesOrder', labelKey: 'orderTracking.table.columns.salesOrder' },
  { id: 'leadTime', labelKey: 'orderTracking.table.columns.leadTime' },
  { id: 'reception', labelKey: 'orderTracking.table.columns.reception' },
  { id: 'linesCount', labelKey: 'orderTracking.table.columns.linesCount' },
  { id: 'linesWithSO', labelKey: 'orderTracking.table.columns.linesWithSO' },
  { id: 'linesWithoutSO', labelKey: 'orderTracking.table.columns.linesWithoutSO' },
];

export function loadOrderTrackingColumnConfig(): Record<string, boolean> {
  try {
    const raw = sessionStorage.getItem(ORDER_TRACKING_TABLE_COLUMN_CONFIG_KEY);
    if (!raw) return { ...DEFAULT_COLUMN_CONFIG };
    const parsed = JSON.parse(raw) as Record<string, boolean>;
    if (parsed && typeof parsed === 'object') {
      const migrated: Record<string, boolean> = { ...DEFAULT_COLUMN_CONFIG, ...parsed };
      // Migración v2/v3 → v4: plazo/progress único; F. pedido on por defecto en key nueva
      if ('deadline' in parsed) delete migrated.deadline;
      if ('progress' in parsed && !('progressUnits' in parsed)) {
        migrated.progressUnits = parsed.progress !== false;
      }
      if ('progress' in parsed) delete migrated.progress;
      return migrated;
    }
  } catch {
    // ignore
  }
  return { ...DEFAULT_COLUMN_CONFIG };
}

export function persistOrderTrackingColumnConfig(config: Record<string, boolean>): void {
  sessionStorage.setItem(ORDER_TRACKING_TABLE_COLUMN_CONFIG_KEY, JSON.stringify(config));
}
